









































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";

var parser = new DOMParser();

const namespace: string = "application";

@Component({
  components: {
    VueEditor,
  },
})
export default class NotificationMessageComponent extends Vue {
  @Prop() mode: string;
  @Prop() recipient: string;
  @Prop() body: any;
  @Prop() subject: any;
  @Prop() disabled: boolean;

  message: any = {
    subject: "",
    body: "",
    notify: true
  };

  toolbar = [
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    ["link"], // remove formatting button
  ];

  mounted() {
    this.message.subject = this.subject;

    if (this.body != null && this.mode != null && this.mode == "workflow") {
      this.stringToHTML(this.body);
    } else {
      this.message.body = this.body;
    }
  }

  CretaeMessage() {
    if(this.message.body.length > 0)
      this.$emit("notfication", this.message);
  }
  CretaeMessageWithoutMail() {
    this.message.notify = false;
    this.$emit("notfication", this.message);
  }

  //takes p tags of each template to display on v-editor
  stringToHTML(html) {
    let template = "";
    var doc = parser.parseFromString(html, "text/html");
    let divTags = doc.getElementsByTagName("div");
    for (let i = 0; i <= divTags.length - 1; i++) {
      for (let j = 0; j <= divTags[i].children.length - 1; j++) {
        template = template + divTags[i].children[j].outerHTML;
      }
    }
    this.message.body = template;
  }

  @Watch("body")
  onPropertyChanged(value: string, oldValue: string) {
    if (this.mode != null && this.mode == "workflow" && value != null) {
      this.stringToHTML(value);
    } else {
      this.message.body = value;
    }
  }

  @Watch("subject")
  onPropertyChanged2(value: string, oldValue: string) {
    this.message.subject = value;
  }
}
